// material-ui
import { styled, Theme } from '@mui/material/styles';
import { ThemeMode } from '@app/types/config';
import { SUPPORT_WIDGET_CLEARANCE } from '@shared/constants/layout';

interface MainStyleProps {
  theme: Theme;
  open: boolean;
  fullPage?: boolean;
}

// ==============================|| MAIN LAYOUT - STYLED ||============================== //

const MainContentStyled = styled('main', {
  shouldForwardProp: (prop) =>
    prop !== 'open' &&
    prop !== 'borderRadius' &&
    prop !== 'menuOrientation' &&
    prop !== 'fullPage',
})(({ theme, open, fullPage }: MainStyleProps) => ({
  backgroundColor:
    theme.palette.mode === ThemeMode.DARK
      ? theme.palette.dark[800]
      : theme.palette.grey[50],
  minWidth: '1%',
  width: '100%',
  minHeight: '100vh',
  flexGrow: 1,
  padding: fullPage ? 0 : 20,
  // Keep the last row of the page clear of the support chat bubble.
  paddingBottom: fullPage ? 0 : SUPPORT_WIDGET_CLEARANCE,
  marginTop: 88,
  marginRight: 0,
  borderRadius: 0,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  ...(!open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter + 200,
    }),
    [theme.breakpoints.up('md')]: {
      marginLeft: 0,
      width: `calc(100% - 260px)`,
      marginTop: 0,
    },
  }),
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.shorter + 200,
    }),
    marginLeft: 0,
    marginTop: 0,
    width: `calc(100% - ${260}px)`,
    [theme.breakpoints.up('md')]: {
      marginTop: 0,
    },
  }),
  [theme.breakpoints.down('md')]: {
    marginLeft: 0,
    padding: 16,
    marginTop: 80,
    ...(!open && {
      width: `calc(100% - 260px)`,
    }),
  },
  [theme.breakpoints.down('sm')]: {
    marginLeft: 0,
    marginRight: 0,
  },
  // ZLAYT-1578: the sidebar is left out of printouts, but this box kept its
  // calc(100% - 260px) width and its padding, so a printed report did not use
  // the paper's width. Last, so it wins over the breakpoints above.
  '@media print': {
    width: '100%',
    margin: 0,
    padding: 0,
    minHeight: 0,
    backgroundColor: '#ffffff',
  },
}));

export default MainContentStyled;
